// import { nanoid } from 'nanoid'
import React from 'react'
// import { setObject } from '../../utils/useful'
// import FormViewer from '../FormViewer'
import { apisObject } from '../../variables/FetchInputApis'
import SelectInput from './SelectInput'
import HttpServices from '../../utils/Http.services'


class ApisInput extends React.Component {

    state = {
        apis: [],
    }


    componentDidMount() {

        this.init()

    }

    componentDidUpdate(prevProps) {
        if (prevProps.header?.information?.frame !== this.props.header?.information?.frame) {
            this.init()
        }
    }
    



    init() {



     
        if (this.props.header?.information?.frame) {
            let body = { filter: {} }

            if (!Array.isArray(this.props.header?.information?.frame)) {
                body.filter._id = [this.props.header?.information?.frame]
            } else {
                body.filter._id = this.props.header?.information?.frame
            }

            HttpServices.request('getFrames', body, (fetchResult, fetchError) => {


                this.setState({ isLoadingHeaders: false })
                if (fetchError) {
                    this.setState({ fetchError })
                    return
                }

                let apis = []


                // TO DO: CONSIDER ADDING THE FRAMES NAMES TO INDICATED DIFFERENT KEYS
                if (Array.isArray(fetchResult.info)) {

                    for (let i = 0; i < fetchResult.info.length; i++) {
                        const frame = fetchResult.info[i];

                        if (apisObject[frame.type]) {

                            apis = apisObject[frame.type].default ? JSON.parse(JSON.stringify(apisObject[frame.type].default )): []

                            if (apisObject[frame.type][frame.mode]) {

                                apis = [...apis, ...(apisObject[frame.type][frame.mode] ?? [])]

                            }

                        }
                    }

                }


               


                this.setState({ apis }, () => {

                    if(apis.length == 1){
                        this.changeValue(null, apis[0].value, null)
                    }

                 })



            })
        } else {
            this.setState({ apis: [] }, () => { })
        }
     
    }


    changeValue=(key,value,extra) =>{
       
            this.props.changeValue(this.props.header?.key, value, this.props.extra)
        
    }
    


    render() {



        return (
            <div className=''>

                <SelectInput data={this.props.data} header={{ information: {type:'local', items: this.state.apis } }} changeValue={this.changeValue}/>

            </div>
        );
    }
}

export default ApisInput;
